// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { operatorId } from './Operator';
import { z } from 'zod';
export const deviceConfigProfileId = (z.number());
export const deviceConfigProfile = z.object({
    id: deviceConfigProfileId,
    device_id: deviceId,
    name: z.string(),
    metadata: z.unknown().nullable(),
    values: z.unknown(),
    is_active: z.boolean(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const deviceConfigProfileInitializer = z.object({
    id: deviceConfigProfileId.optional(),
    device_id: deviceId,
    name: z.string(),
    metadata: z.unknown().optional().nullable(),
    values: z.unknown().optional(),
    is_active: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const deviceConfigProfileMutator = z.object({
    id: deviceConfigProfileId.optional(),
    device_id: deviceId.optional(),
    name: z.string().optional(),
    metadata: z.unknown().optional().nullable(),
    values: z.unknown().optional(),
    is_active: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DeviceConfigProfile.js.map